import { FC } from "react";

import { BasicWidgetProps } from "src/dynamic-view-renderer/Widgets/BasicWidget/BasicWidget.tsx";

import WidgetBlacklistSchema from "./WidgetBlacklistSchema";
import WidgetCaseSchema from "./WidgetCaseSchema";
import WidgetCustomerSchema from "./WidgetCustomerSchema";

const WidgetSchema: FC<Omit<BasicWidgetProps, "itemSchema">> = (props) => {
  const itemType = props.data?.item?.type;

  switch (itemType) {
    case "blacklist":
      return <WidgetBlacklistSchema {...props} />;
    case "customer":
      return <WidgetCustomerSchema {...props} />;
    default:
      return <WidgetCaseSchema {...props} />;
  }
};

export default WidgetSchema;
